export default __webpack_public_path__ + "static/media/product_2.02b472b7.png";